export interface FreeShippingMetadata {
  spendLimit: number;
  applicableCities?: string[];
}

export const getEmptyFreeShippingMetadata = (): FreeShippingMetadata => ({
  spendLimit: 0,
});

export const freeShippingMetadataFromResponse = (
  responseData: any,
): FreeShippingMetadata => ({
  spendLimit: responseData.spend_limit,
  applicableCities: responseData.applicable_cities,
});

export const freeShippingMetadataToUpsertRequest = (
  metadata: FreeShippingMetadata,
) => ({
  spend_limit: metadata.spendLimit,
  applicable_cities: metadata.applicableCities,
});
